export interface DeferredVideoSources {
  mp4: string;
  webm: string;
}

const WEBM_MIME_TYPE = 'video/webm; codecs="vp8, opus"';

export function selectDeferredVideoSource(
  video: HTMLVideoElement,
  sources: DeferredVideoSources,
): string {
  return video.canPlayType(WEBM_MIME_TYPE) ? sources.webm : sources.mp4;
}

export function playDeferredVideo(
  video: HTMLVideoElement,
  sources: DeferredVideoSources,
  restart = false,
): Promise<void> {
  const source = selectDeferredVideoSource(video, sources);
  const isNewSource = video.getAttribute('src') !== source;

  video.preload = 'auto';
  if (isNewSource) {
    video.src = source;
  } else if (restart) {
    // Reset the media pipeline so partially loaded videos can replay reliably.
    video.load();
  }

  return video.play();
}
